import { IMPACT_CAMPAIGN_ID } from "../constants";

export const getCookie = (key) => {
    let cookieValue;
    if (document.cookie && document.cookie !== "") {
        let cookies = document.cookie.split(";");
        for (let x = 0; x < cookies.length; x++) {
            let cookie = cookies[x].trim().split("=");
            if (cookie[0] === key) {
                cookieValue = cookie[1];
                break;
            }
        }
    }

    return cookieValue;
};

export const removeCookie = (key) => {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export const getImpactCookie = () => {

    let impactCookie = getCookie("IR_" + process.env.REACT_APP_IMPACT_CAMPAIGN_ID);

    if (impactCookie) {
        impactCookie = impactCookie.split("%7C");

        return impactCookie[impactCookie.length - 2];
    } else {
        return false;
    }

};

export const getBRGPatientCookie = () => {

    let eventID = getCookie("indi-brgp-event-id");
    let id = getCookie("indi-brgp-id");
    let signupType = getCookie("indi-signup-type");

    if (eventID && id && signupType) {

        if (signupType == "brgpatient") {
            return {
                eventID,
                emailID: id,
                signupType
            };
        } else if (signupType == "therapistinvite") {
            return {
                eventID,
                therapist: id,
                signupType
            };
        }

    } else {
        return null;
    }
}

export const removeBRGPatientCookie = () => {
    document.cookie = `indi-brgp-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.indimoves.com; path=/; Secure; SameSite=None`;
    document.cookie = `indi-brgp-event-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.indimoves.com; path=/; Secure; SameSite=None`;
    document.cookie = `indi-signup-type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.indimoves.com; path=/; Secure; SameSite=None`;
}

export const setUpCookiesFromInvitation = () => {
    const params = new URLSearchParams(window.location.search);
    const type = params.get("type");
    const id = params.get("id");
    const event_id = params.get("event_id");
    if (type) document.cookie = `indi-signup-type=${type}; domain=.indimoves.com; path=/; Secure; SameSite=None`;
    if (id) document.cookie = `indi-brgp-id=${id}; domain=.indimoves.com; path=/; Secure; SameSite=None`;
    if (event_id) document.cookie = `indi-brgp-event-id=${event_id}; domain=.indimoves.com; path=/; Secure; SameSite=None`;

    // Create the payload for the API call
    const payload = {
        type: type,
        id: id,
        event_id: event_id,
    };

    // Make the POST API call
    const env = params.get("e");
    const api = env == "p" ? "https://api.indimoves.com" : "https://api-dev.indimoves.com";
    fetch(`${api}/v2/user/generated-link-clicked`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Accept": "application/json",
        },
        body: JSON.stringify(payload)
    })
}